import axiosInstance from "../axiosConfig";
import { ADMIN_API_URL } from "../config/apiParams";

export const loginUserAPI = async (data) => {
    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'accept': 'application/json'
        }
    }
    const response = await axiosInstance.post(`${ADMIN_API_URL}/user/login`, {
        username: data?.username,
        password: data?.password,
    }, config);

    if (response.status !== 200) {
        throw new Error('Login failed');
    }

    // Store tokens in local storage
    const { access_token, refresh_token } = response.data;
    localStorage.setItem('access_token', access_token);
    localStorage.setItem('refresh_token', refresh_token);

    return response.data;
};

export const getUserInfo = async (data) => {
    const { access_token, token_type, organisationId, projectId } = data;

    const headers = {
        'accept': 'application/json',
        'org-id': `${organisationId}`,
        'proj-id': `${projectId}`,
        'Authorization': `${token_type} ${access_token}`
    }

    let response;

    try {
        response = await axiosInstance({
            url: `${ADMIN_API_URL}/user/me`,
            method: "GET",
            headers: headers
        });

        console.log("User Me API Response:", response?.data);

        return response?.data;
    } catch (error) {
        console.error('Error fetching user info:', error);
    }
}

export const createUser = async ({ user, access_token, token_type }) => {
    const response = await axiosInstance({
        url: `${ADMIN_API_URL}/user/`,
        method: "POST",
        data: user,
        headers: {
            'Authorization': `${token_type} ${access_token}`
        },
    });
    if (response.status !== 200) {
        throw new Error('No response from the network');
    }

    return response.data;
}

export const refreshAccessToken = async (refreshToken) => {
    try {
        const response = await axiosInstance.post(`${ADMIN_API_URL}/user/refresh-token?refresh_token=${refreshToken}`, null, {
            headers: {
                'accept': 'application/json',
            }
        });

        if (response.status !== 200) {
            throw new Error('Failed to refresh access token');
        }

        // Store new tokens in local storage
        const { access_token, refresh_token } = response.data;
        localStorage.setItem('access_token', access_token);
        localStorage.setItem('refresh_token', refresh_token);

        return response.data;
    } catch (error) {
        console.error('Error refreshing access token:', error);
        throw error;
    }
};